import {
  INIT_SAVINGS,
  SavingsActions,
  SET_SAVINGS_INPUTS,
  SET_SAVINGS_RESULT,
} from '../actions/actionTypes'
import { ISavingsCalc } from '../store/createStore'

const savingsReducer = (
  state: ISavingsCalc,
  action: SavingsActions,
): ISavingsCalc => {
  switch (action.type) {
    case INIT_SAVINGS:
      return {
        ...state,
        savingsInputs: action.inputs,
        savingsResult: action.result,
      }
    case SET_SAVINGS_INPUTS:
      return { ...state, savingsInputs: action.inputs }
    case SET_SAVINGS_RESULT:
      return { ...state, savingsResult: action.result }
    default:
      return { ...state }
  }
}

export default savingsReducer
